/**
 * InternalTicketsPage — admin/work Trello, totally separate from the
 * customer-facing "assistance" tickets. Shares the same component code
 * (`TicketsKanban`) but points to a different backend scope and uses
 * a different visual accent.
 */
import React from "react";
import { TicketsKanban } from "./TicketsPage";

export default function InternalTicketsPage() {
  return (
    <TicketsKanban
      basePath="/internal-tickets"
      title="Tickets internes"
      subtitle="Workflow de travail interne de l'équipe Norea — tâches administratives, suivi, organisation."
      accent="accent"
      testidPrefix="internal-tickets"
    />
  );
}
